import { render } from "./IConfirmationDialog.vue?vue&type=template&id=7c5516f6"
import script from "./IConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./IConfirmationDialog.vue?vue&type=script&lang=js"

import "./IConfirmationDialog.vue?vue&type=style&index=0&id=7c5516f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__